import "./email.styles.css"
const Email = (props) => {

    return (
        <div className="page-end">
            <div className="bottom-header">יש לכם שאלה? בקשה?</div>
            <div className="bottom-header">מעוניינים ליצור עימנו קשר?</div>
            <a className="info-txt" href="mailto:know.it.till@gmail.com">know.it.till@gmail.com</a>
        </div>
        
    )
}
export default Email;